import isArray from 'lodash/isArray';
import includes from 'lodash/includes';
import store from '@/store';
import { DEPARTMENT } from '@/enum/UserDepartments';


export function requiresDepartment(departments) {
  if (!isArray(departments)) {
    departments = [departments];
  }
  return (to, from, next) => {
    const userDepartment = store.getters['User/user'].departmentId;
    if (includes(departments, userDepartment)) {
      next();
    } else {
      next(new Error('Navigation to route is blocked for the current user.'));
    }
  };
}

export function requiresAdmin() {
  return requiresDepartment([
    DEPARTMENT.ADMIN,
    DEPARTMENT.SUPER_ADMIN,
  ]);
}

export function requiresManager(additionalAllowedRoles = []) {
  return requiresDepartment([
    DEPARTMENT.MANAGER,
    DEPARTMENT.DISTRICT_MANAGER,
    DEPARTMENT.ADMIN,
    DEPARTMENT.SUPER_ADMIN,
  ].concat(additionalAllowedRoles));
}

export default {
  requiresDepartment,
  requiresAdmin,
  requiresManager,
};
